import { LogOut, Clock, Ban } from 'lucide-react';

export default function AccountGateView({ status, email, onLogout }) {
  const isPending = status === 'PENDING';
  const Icon = isPending ? Clock : Ban;
  const tone = isPending ? 'var(--warning)' : 'var(--danger)';
  const message = isPending
    ? "Votre compte est en attente d'activation par un administrateur."
    : 'Votre compte a été désactivé. Contactez un administrateur.';

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        style={{
          maxWidth: 460,
          width: '100%',
          background: 'var(--card-bg)',
          border: '1px solid var(--glass-border)',
          borderRadius: 'var(--radius-md)',
          padding: 32,
          boxShadow: 'var(--shadow-card)',
          textAlign: 'center',
        }}
      >
        <Icon size={36} color={tone} style={{ marginBottom: 16 }} />
        <h2 style={{ margin: '0 0 12px', color: 'var(--text)' }}>
          {isPending ? 'Compte en attente' : 'Compte désactivé'}
        </h2>
        <p
          style={{
            margin: '0 0 8px',
            color: 'var(--text-muted)',
            fontSize: 14,
          }}
        >
          {message}
        </p>
        <p
          style={{
            margin: '0 0 24px',
            color: 'var(--text)',
            fontSize: 13,
            fontWeight: 500,
          }}
        >
          {email}
        </p>
        <button
          type="button"
          onClick={onLogout}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            background: 'transparent',
            color: 'var(--text)',
            border: '1px solid var(--glass-border)',
            borderRadius: 'var(--radius-sm)',
            padding: '10px 18px',
            fontSize: 14,
          }}
        >
          <LogOut size={16} />
          Se déconnecter
        </button>
      </div>
    </div>
  );
}
